const fab = document.querySelector(".floating-action-btn");
const fabBtn = document.querySelector(".floating-action-btn__button");
const whastappBtn = document.querySelector(".floating-action-btn__whatsapp");
const instagramBtn = document.querySelector(".floating-action-btn__instagram");

const TABLET = 800;
const MOBILE = 537;

let isMobile = false;

const mouseOverHeight = () => {
  if (window.innerWidth <= TABLET) {
    return "176px";
  }

  if (window.innerWidth <= MOBILE) {
    return "176px";
  }

  return "210px";
};

const mouseOutHeight = () => {
  if (window.innerWidth <= TABLET) {
    return "62px";
  }

  if (window.innerWidth <= MOBILE) {
    return "62px";
  }

  return "75px";
};

const startWhatsapp = () => {
  if (isMobile) {
    if (window.innerWidth <= MOBILE) {
      return "164px";
    }

    return "186px";
  }
  if (window.innerWidth <= TABLET) {
    return "140px";
  }

  if (window.innerWidth <= MOBILE) {
    return "140px";
  }

  return "164px";
};

const startInstagram = () => {
  if (isMobile) {
    if (window.innerWidth <= MOBILE) {
      return "112px";
    }

    return "126px";
  }
  if (window.innerWidth <= TABLET) {
    return "86px";
  }

  if (window.innerWidth <= MOBILE) {
    return "86px";
  }

  return "106px";
};

const endBtn = () => {
  if (isMobile) {
    return "58px";
  }
  if (window.innerWidth <= TABLET) {
    return "24px";
  }

  if (window.innerWidth <= MOBILE) {
    return "24px";
  }

  return "32px";
};

const startEvent = () => {
  fab.style.height = mouseOverHeight();
  fab.classList.remove("rotate-out");
  fab.classList.add("rotate-in");
  whastappBtn.style.bottom = startWhatsapp();
  instagramBtn.style.bottom = startInstagram();
};

const endEvent = () => {
  fab.style.height = mouseOutHeight();
  fab.classList.remove("rotate-in");
  fab.classList.add("rotate-out");
  whastappBtn.style.bottom = endBtn();
  instagramBtn.style.bottom = endBtn();
};

window.addEventListener("load", () => {
  const platform =
    navigator?.userAgentData?.platform ||
    navigator?.userAgent ||
    navigator?.platform ||
    "unknown";

  if (platform.includes("Android") || /iPhone|iPod|iPad/.test(platform)) {
    isMobile = true;

    fabBtn.style.bottom = "46px";
    fabBtn.style.right = "48px";

    fab.style.bottom = "42px";
    fab.style.right = "42px";

    whastappBtn.style.right = window.innerWidth <= MOBILE ? "54px" : "60px";
    whastappBtn.style.bottom = "58px";

    instagramBtn.style.right = window.innerWidth <= MOBILE ? "54px" : "60px";
    instagramBtn.style.bottom = "58px";
  }

  fab.addEventListener("mouseover", startEvent);
  fab.addEventListener("mouseout", endEvent);

  if (isMobile) {
    fab.removeEventListener("mouseover", startEvent);
    fab.removeEventListener("mouseout", endEvent);

    fab.addEventListener("click", startEvent);

    document.addEventListener("click", (event) => {
      const withinBoundaries = event.composedPath().includes(fab);
      if (!withinBoundaries) {
        endEvent();
      }
    });
  }
});
